// extracted by mini-css-extract-plugin
module.exports = {"bodyreset":"resets-module--bodyreset--2b0YA"};